import React from "react"
import Button from 'react-bootstrap/Button'

export default function HandleButton({ text, ...props}) {
  return (
    <Button variant="secondary" size="sm" className="mr-3 mb-1" {...props}>
      { text }
    </Button>
  )
}